import { BaseModule } from "./base.module";
import PureParagraphs from "./pure-paragraphs.module";

export class GooglePublisherTagModule extends BaseModule {
	initialize() {
        this.postContentSelector = ".post-main-content";
        this.adId = "div-gpt-ad-sb1"

		if (typeof window !== 'undefined') {
            let boundGooglePublisherTagCommandsHandler = this.handleGooglePublisherTagCommands.bind(this);
            window.addEventListener('DOMContentLoaded', boundGooglePublisherTagCommandsHandler);  
        }
	}

	handleGooglePublisherTagCommands() {
		const boundSingleAdHandler = this.handleSingleAd.bind(this);

        if (typeof window !== 'undefined' && window.googletag) {
            window.googletag.cmd.push(boundSingleAdHandler);
        } else{
            console.info('There is no googletag element present because of user agent choice, or googletag was not loaded');
        }
	}

	handleSingleAd() {
		const postContent = document.querySelector(this.postContentSelector);

        if (postContent) {
            const pureParagraphs = new PureParagraphs(postContent);
            const paragraphs = pureParagraphs.paragraphs;
            
            if (paragraphs.length < 2) return;

            const firstParagraphWithAd = paragraphs[1];

            const adScript = document.createElement('script');
            adScript.innerHTML = `
                googletag.cmd.push(function() {
                    googletag.display('${this.adId}');
                });
            `

            const adDiv = document.createElement('div');
            adDiv.id = this.adId;
            // Local test ad, comment out to test:
            // adDiv.innerHTML = `
            //     <div class="test-ad" style="height: 600px; width: 300px; margin: 0 auto;">
            //         <img src="https://tpc.googlesyndication.com/pimgad/10546857817837052601?" style="height: 600px; width: 300px;" />
            //     </div>
            // `
            adDiv.appendChild(adScript);

            firstParagraphWithAd.insertAdjacentElement('beforebegin', adDiv);

            this.observeAdLoad(adDiv);
        }
	}
    
    observeAdLoad(adDiv) {
        // Observing when the ad is loaded. If it is active (has a height), we add the margin bottom.
        // Otherwise, there will be weird margin when there's no ad.
        const config = { childList: true, subtree: true };

        const mutationCallback = (mutationsList, observer) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    const adHeight = adDiv.offsetHeight;
                    if (adHeight > 0) adDiv.classList.add("mb-2")
                }
            }
        };

        const observer = new MutationObserver(mutationCallback);
        observer.observe(adDiv, config);
    }
}